import { motion } from 'framer-motion'
import { useAuthContext } from '~/src/context/AuthProvider'
import useAuthUser from '~/src/hooks/useAuthUser'
import { cn } from '~/src/lib/utils'

interface Props extends React.HTMLAttributes<HTMLDivElement> {}

const AuthButtons: React.FC<Props> = ({ className }) => {
  const { loading, authUserNotAnonymous } = useAuthUser()
  const { openAuthModal } = useAuthContext()

  if (loading || authUserNotAnonymous) return null

  return (
    <motion.button
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className={cn(
        'flex items-center gap-3',
        'h-10 rounded-full border border-black/30 px-4 py-1 text-sm font-semibold backdrop-blur-md transition-colors hover:bg-black hover:text-white',
        className
      )}
      onClick={() =>
        openAuthModal({
          source: 'header-signup',
        })
      }
    >
      Sign up
    </motion.button>
  )
}

export default AuthButtons
